/* eslint-disable */
import React from 'react'
import { message, Modal, notification, Button } from 'antd'
import actionTypes from '../constants/actionTypes'
import fetchHelper from '../utils/fetchHelper'
import exceptionHelper from '../utils/exceptionHelper'
import { captureFetchException } from '../utils/sentryUtils'
import { abtest } from '../utils/sensors'
import CONFIG from '../constants/config'
import { createQueryPhotoAuth } from '../app/authPolicyHooks'
import { setPhotoStatistics as setPhotoStatisticsAction } from '../slices/groupSlice'
import {
  setPhotos as setPhotosAction,
  appendPhotos as appendPhotosAction,
  setPhotosFilter as setPhotosFilterAction,
  resetFilter as resetFilterAction,
  setQueryFilter as setQueryFilterAction,
  setLastPageCond as setLastPageCondAction,
  setExportListDrawerVisible as setExportListDrawerVisibleAction,
  setAiVisualSearchAB as setAiVisualSearchABAction,
  setPhotosNum as setPhotosNumAction,
  setCheckAll as setCheckAllAction,
  clearCheckedPhoto as clearCheckedPhotoAction,
  setCanFavorite as setCanFavoriteAction,
  setIsGroupPhotoViewLimit as setIsGroupPhotoViewLimitAction,
  setExportTasks as setExportTasksAction,
  setExportTaskTimer as setExportTaskTimerAction,
  setOldPhotosCount as setOldPhotosCountAction,
  updatePhotoRectification as updatePhotoRectificationAction,
  setClientDownloadDrawerVisible as setClientDownloadDrawerVisibleAction,
  setClientDownloadTasks as setClientDownloadTasksAction,
  setClientDownloadProgress as setClientDownloadProgressAction,
  setCurrentViewPhoto as setCurrentViewPhotoAction
} from '../slices/photoSlice'
import {
  ExclamationCircleOutlined,
  FrownOutlined,
  SmileOutlined
} from '@ant-design/icons'

export function setPhotos(data) {
  return setPhotosAction(data)
}

export function setFilter(data) {
  return (dispatch, getState) => {
    dispatch(setPhotosFilterAction(data))
    return Promise.resolve()
  }
}

export function resetFilter() {
  return (dispatch, getState) => {
    dispatch(resetFilterAction())
    // 返回重置后的 queryFilter，供调用方更新 ref
    const resetQueryFilter = getState().photo.queryFilter
    return Promise.resolve(resetQueryFilter)
  }
}

export function setQueryFilter(data) {
  return (dispatch, getState) => {
    dispatch(setQueryFilterAction(data))
    return Promise.resolve()
  }
}

export function setLastPageCond(data) {
  return setLastPageCondAction(data)
}

export function setExportListDrawerVisible(data) {
  return setExportListDrawerVisibleAction(data)
}

export function setAIVisualSearchAB(data) {
  return setAiVisualSearchABAction(data)
}

export const buildParamsWithAuthPolicy = (state: any, data: any) => {
  const group = state.group
  const userID = state.main.user?.user_id
  const photoViewAuthPolicy = createQueryPhotoAuth(group, userID)
  const params = JSON.parse(JSON.stringify(data))

  // 如果没有filter属性，直接返回原参数
  if (!params.filter) {
    return params
  }

  const { departmentIDList, userIDList } = params.filter
  if (
    (!departmentIDList || departmentIDList.length === 0) &&
    (!userIDList || userIDList.length === 0)
  ) {
    params.filter.departmentIDList =
      photoViewAuthPolicy?.departmentIDList?.map((item) => String(item)) || []
    params.filter.userIDList = photoViewAuthPolicy?.userIDList || []
  }
  return params
}

// 获取90天前的照片数量
export function fetch90DaysPhotosCount(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/v5/workgroup/photos/notvip/count',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(buildParamsWithAuthPolicy(getState(), data))
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function fetchPhotos(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/v5/workgroup/photos',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(buildParamsWithAuthPolicy(getState(), data)) //接入权限中心
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        const { payload, status } = result
        if (status === 0) {
          dispatch(setPhotosAction(payload.photos))
          dispatch(setCanFavoriteAction(payload.canSetFavorite))
          dispatch(setPhotosNumAction(payload.total))
          dispatch(setLastPageCondAction(payload.lastPageCond))
          dispatch(
            setIsGroupPhotoViewLimitAction(payload.isGroupPhotoViewLimit)
          )
          dispatch({
            type: actionTypes.SET_LOADING,
            data: false
          })
          return Promise.resolve(result)
        } else if (status === -3) {
          Modal.warning({
            title: '提示',
            content: '您已退出或被移出当前群',
            onOk: () => {
              window.location.href = '/'
            }
          })
        } else if (status === -34) {
          Modal.warning({
            title: '提示',
            content:
              '照片搜索服务正在升级中，预计2月20日升级完成。升级期间的照片数据会安全保存，不会丢失。'
          })
        } else if (status === -991) {
          Modal.warning({
            title: '提示',
            content: '暂无照片查看权限'
          })
          dispatch(setPhotosAction([]))
          dispatch(setPhotosNumAction(0))
        }
        return Promise.reject(result)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

export function fetchMorePhotos(data) {
  return (dispatch, getState) => {
    //使用全局Spin会导致鼠标滚轮滚动加载更多后，列表回到顶部，未找到原因
    // dispatch({
    //   type: actionTypes.SET_LOADING,
    //   data: true
    // })
    let config = {
      url: __API_SERVER_HOST__ + '/v5/workgroup/photos',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(buildParamsWithAuthPolicy(getState(), data)) //接入权限中心
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        const { payload, status } = result
        if (status === 0) {
          dispatch(appendPhotosAction(payload.photos))
          dispatch(setLastPageCondAction(payload.lastPageCond))
          dispatch(
            setIsGroupPhotoViewLimitAction(payload.isGroupPhotoViewLimit)
          )
        } else if (status === -3) {
          Modal.warning({
            title: '提示',
            content: '您已退出或被移出当前群',
            onOk: () => {
              window.location.href = '/'
            }
          })
        } else if (status === -991) {
          Modal.warning({
            title: '提示',
            content: '暂无照片查看权限'
          })
          dispatch(setPhotosAction([]))
          dispatch(setPhotosNumAction(0))
        }
        return Promise.resolve(result)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

// 获取导出示例列表（用于多级文件夹预览）
export function fetchExportList(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/v5/workgroup/photos/export/list',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(buildParamsWithAuthPolicy(getState(), data))
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        return Promise.resolve(result)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(err)
      })
  }
}

export function exportPhotos(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/v5/workgroup/photos/export',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(buildParamsWithAuthPolicy(getState(), data)) //接入权限中心
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        const { payload, status } = result
        if (status === -3) {
          Modal.warning({
            title: '提示',
            content: '您已退出或被移出当前群',
            onOk: () => {
              window.location.href = '/'
            }
          })
        }
        if (status === -33) {
          Modal.info({
            title: '有正在处理中的任务，请等待任务完成之后再试'
          })
        }
        if (status === -202) {
          Modal.warning({
            title: '提示',
            content: '选择时间段内无照片'
          })
        }
        return Promise.resolve(result)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(err)
      })
  }
}

export function exportPhotosAsExcel(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/v5/workgroup/photos/excel/export',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(buildParamsWithAuthPolicy(getState(), data)) //接入权限中心
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        const { payload, status } = result
        if (status === -3) {
          Modal.warning({
            title: '提示',
            content: '您已退出或被移出当前群',
            onOk: () => {
              window.location.href = '/'
            }
          })
        }
        if (status === -33) {
          Modal.info({
            title: '有正在处理中的任务，请等待任务完成之后再试'
          })
        }
        return Promise.resolve(result)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(err)
      })
  }
}

export function photoTitles(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/v5/workgroup/photos/export/titles',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(buildParamsWithAuthPolicy(getState(), data)) //接入权限中心
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

// 获取多级下载 / 命名试用次数信息
export function fetchTrialCount(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/v5/workgroup/photos/export/trial_count',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(buildParamsWithAuthPolicy(getState(), data))
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        return Promise.resolve(result)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

/**
 * 打包下载任务的任务级状态（`/v6/workgroup/downloads` 的 items[].status）。
 *
 * 2026-09-07 服务端新增。此前只有压缩包级的 status，任务刚创建、压缩包尚未产出时
 * `zips` 为空，无从区分「还在打包」和「打包不出来了」，只能靠 failedPhotoCount 猜，
 * 照片解冻上线后这个猜测会误判——冷冻照片在打包前就被过滤并计入 failedPhotoCount，
 * 任务刚创建就会被当成整体失败。现在直接读任务状态。
 */
const EXPORT_TASK_STATUS = {
  PROCESSING: 1,
  DONE: 2,
  FAILED: 3
} as const

export function fetchExportTasksV3() {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/v6/workgroup/downloads',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          groupID: getState().group.groupId
        })
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        const prevTasks = getState().photo.exportTasks
        const { data } = result
        if (data.status === 0) {
          const tasks = data.items
          dispatch(setExportTasksAction(tasks))
          let hasProcessing = false

          tasks.forEach((curTask) => {
            const prevTask = prevTasks.find(
              (prevTaskItem) => prevTaskItem.taskID === curTask.taskID
            )
            const curZips = curTask.zips
            //本次任务中处理失败、未打包进压缩包的照片张数（老数据没有这个字段）
            const failedPhotoCount = curTask.failedPhotoCount || 0
            const isTaskFailed = curTask.status === EXPORT_TASK_STATUS.FAILED
            //检查是否有进行中的任务
            if (curTask.status === EXPORT_TASK_STATUS.PROCESSING) {
              hasProcessing = true
            }
            if (!getState().photo.exportListDrawerVisible) {
              if (prevTask) {
                const prevZips = prevTask.zips
                //任务是否已经有结果了：不再是处理中即为已结算
                const isTaskSettled =
                  curTask.status !== EXPORT_TASK_STATUS.PROCESSING
                const wasTaskSettled =
                  prevTask.status !== EXPORT_TASK_STATUS.PROCESSING
                //有照片失败时不弹成功通知，改为在任务结算时弹一次部分失败通知
                if (failedPhotoCount > 0) {
                  if (isTaskSettled && !wasTaskSettled) {
                    notification.open({
                      title: isTaskFailed
                        ? '任务处理失败'
                        : '任务处理完成，部分照片失败',
                      duration: 0,
                      description: isTaskFailed
                        ? `本次 ${failedPhotoCount} 张照片全部处理失败，请重新发起下载。`
                        : `本次有 ${failedPhotoCount} 张照片处理失败，其余照片可正常下载。`,
                      icon: isTaskFailed ? (
                        <FrownOutlined style={{ color: '#E4004C' }} />
                      ) : (
                        <ExclamationCircleOutlined
                          style={{ color: '#FAAD14' }}
                        />
                      ),
                      actions: (
                        <Button
                          type="primary"
                          size="small"
                          onClick={() => {
                            notification.destroy()
                            dispatch(setExportListDrawerVisible(true))
                          }}
                        >
                          查看列表
                        </Button>
                      )
                    })
                  }
                } else if (
                  //检查是否有新完成的子任务。
                  //这里按压缩包粒度统计，不换成任务级 status：一个任务会分批产出多个
                  //压缩包，每产出一个就提醒一次，用户可以先下已完成的，不必等全部打完
                  curZips.filter((zip) => zip.status === 2).length >
                  prevZips.filter((zip) => zip.status === 2).length
                ) {
                  //成功通知
                  notification.open({
                    title: '任务处理完成',
                    duration: 0,
                    description: '任务处理完成，可以进行下载。',
                    icon: <SmileOutlined style={{ color: '#108ee9' }} />,
                    actions: (
                      <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                          notification.destroy()
                          dispatch(setExportListDrawerVisible(true))
                        }}
                      >
                        查看列表
                      </Button>
                    )
                  })
                }
                //检查是否有新异常的子任务，同样是压缩包粒度：
                //单个压缩包异常不代表整个任务失败，任务级 status 覆盖不了这一层
                if (
                  curZips.filter((zip) => zip.status === 3).length >
                  prevZips.filter((zip) => zip.status === 3).length
                ) {
                  //失败通知
                  notification.open({
                    title: '任务异常',
                    duration: 0,
                    description: '下载任务异常，请查看下载列表。',
                    icon: <FrownOutlined style={{ color: '#E4004C' }} />,
                    actions: (
                      <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                          notification.destroy()
                          dispatch(setExportListDrawerVisible(true))
                        }}
                      >
                        查看列表
                      </Button>
                    )
                  })
                }
              }
            }
          })

          if (hasProcessing) {
            if (!getState().photo.exportTaskTimer) {
              const fn = () => dispatch(fetchExportTasksV3())
              const timer = setInterval(fn, 3 * 1000)
              dispatch(setExportTaskTimerAction(timer))
            }
          } else {
            clearInterval(getState().photo.exportTaskTimer)
            dispatch(setExportTaskTimerAction(null))
          }
        }
        if (data.status === -3) {
          Modal.warning({
            title: '提示',
            content: '您已退出或被移出当前群',
            onOk: () => {
              window.location.href = '/'
            }
          })
        }
        return Promise.resolve(data)
      })
      .catch((err) => {
        captureFetchException(err, config)
      })
  }
}

/**
 * 查询某个下载任务里处理失败的照片详情。
 * 后端会校验任务归属，任务不存在或不属于当前用户时返回 404
 *
 * @param taskID 下载列表接口返回的加密任务 ID
 * @returns 接口 data 部分（含 failedPhotoCount 与 failedPhotos）
 */
export function fetchDownloadFailedPhotos(taskID: string) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/v6/workgroup/downloads/failed_photos',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ taskID })
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        const { data } = result
        if (data?.status !== 0) {
          return Promise.reject(result)
        }
        return Promise.resolve(data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(err)
      })
  }
}

export function deletePhoto(data) {
  let seqs = data.photo_list
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/v3/batch/remove/photo',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then(exceptionHelper)
      .then((data) => {
        // exceptionHelper 对部分错误码 resolve（如 -206 超 2000 张），不可当成功处理
        if (data.status !== 0) {
          return Promise.resolve(data)
        }
        message.success('操作成功')
        dispatch(clearCheckedPhotoAction())
        const state = getState()
        let photoList = [...state.photo.photos]
        const { realDeletePhotoList = [] } = data

        if (realDeletePhotoList.length) {
          seqs.forEach((seq) => {
            if (realDeletePhotoList.includes(seq)) {
              const index = photoList.findIndex((photo) => photo.seq === seq)

              if (index > -1) {
                photoList.splice(index, 1)
              }
            }
          })
        }

        dispatch(setPhotosAction(photoList))
        dispatch(setPhotosNumAction(getState().photo.photosNum - seqs.length))
        return Promise.resolve(data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

export function deletePhotosV2(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/remove/all/photo',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then(exceptionHelper)
      .then((data) => {
        message.success('操作成功')
        dispatch(clearCheckedPhotoAction())
        dispatch(setCheckAllAction(false))
        return Promise.resolve(data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() =>
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      )
  }
}

export function fetchDeleteRecords(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/delete/photo/record',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function fetchWatermarkByUrl(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/v4/workgroup/user/watermarks',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then(exceptionHelper)
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function fetchWatermarkList(data) {
  return (dispatch, getState) => {
    let config = {
      url:
        __API_SERVER_HOST__ +
        `/v4/workgroup/watermarks?group_id=${data.groupID}`,
      arguments: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then(exceptionHelper)
      .then((data) => {
        return Promise.resolve(data.payload)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function favoritePhoto(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + `/web/album/photos/favorites/add`,
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function removeFavoritePhoto(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + `/web/album/photos/favorites/remove`,
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function fetchLocations(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + `/workgroup/locations`,
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function fetchPhotoStatistics(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + `/v5/workgroup/photos/stat`,
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function setPhotoStatistics(data) {
  return setPhotoStatisticsAction(data)
}

export function fetchAndStorePhotoStatistics(data, forceRefresh = false) {
  return (dispatch, getState) => {
    const existing = getState().group && getState().group.statistics
    // forceRefresh：绕过缓存强制拉 /stat。团队信息接口(query/group)会把 statistics
    // 占坑成缺字段的残缺对象，非强制时会短路掉真正的 /stat 请求，导致统计恒为 0。
    if (existing && !forceRefresh) {
      return Promise.resolve(existing)
    }
    return dispatch(fetchPhotoStatistics(data)).then((res) => {
      if (!res) return Promise.reject(null)
      let payload = null
      if (res.status === 0) {
        payload = res
      } else if (res.code === 200 && res.data) {
        payload = res.data
      } else if (res.payload) {
        payload = res.payload
      }

      if (payload) {
        dispatch(setPhotoStatistics(payload))
        return payload
      }
      return Promise.reject(null)
    })
  }
}

export function fetchRecommendSearchKeywords(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + `/v5/workgroup/photos/search/recommend`,
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

/**
 * 创建照片处理任务
 * @param {*} data
 * @returns
 */
export function createProducePhotoTask(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + `/web/photocalculation/task/create`,
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

// 照片处理任务进度查询
export function queryTaskStatus(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + `/web/photocalculation/task/query`,
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

// 下载去水印的照片
export function removeWatermarkDownload(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + `/web/workgroup/watermark/remove/save`,
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

// 批量去水印前置校验
export function batchRemoveWatermarkCheck(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + `/web/photocalculation/task/check`,
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function fetchRecommendKeywordsByInput(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + `/web/xrecommend/photosearch`,
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function createComments(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + `/web/photo/comment/create`,
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

// ai图片变清晰接口
// 创建任务
export function aiClearCreateTask(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + `/web/agent/photo/task/create`,
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}
// 查询任务
export function aiClearQueryTask(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + `/web/agent/photo/task/query`,
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}
// 取消任务
export function aiClearCancelTask(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + `/web/agent/photo/task/cancel`,
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

// 90天前的照片数量
export const setOldPhotosCount = (count) => setOldPhotosCountAction(count)

export function exportFolderAndPhotos(data) {
  return (dispatch, getState) => {
    // 构建请求参数，添加时间范围参数
    const requestData = {
      ...data,
      startTime: data.startTime || 0,
      endTime: data.endTime || 0
    }

    let config = {
      url: __API_SERVER_HOST__ + '/web/folder/photo/export',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(buildParamsWithAuthPolicy(getState(), requestData)) //接入权限中心
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        // 适配新接口格式: { code, msg, data: { status, requestID } }
        const { code, data } = result
        const { status, requestID } = data || {}

        if (status === -3) {
          Modal.warning({
            title: '提示',
            content: '您已退出或被移出当前群',
            onOk: () => {
              window.location.href = '/'
            }
          })
        }
        if (status === -202) {
          message.warning('文件夹内无照片或选择时间段内无照片')
        }
        if (status === -33) {
          Modal.info({
            title: '有正在处理中的任务，请等待任务完成之后再试'
          })
        }
        if (code === 200) {
          // 返回兼容旧格式的数据，保持payload字段给后续代码使用
          return {
            ...result,
            payload: requestID,
            status: status
          }
        }
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

/**
 * 更新照片的整改字段
 * @param {Object} params - 更新参数
 * @param {string} params.photoUrl - 照片URL（用于匹配照片）
 * @param {Object} params.photoRectification - 整改信息
 * @param {boolean} params.photoRectification.exist - 是否存在整改
 * @param {number} params.photoRectification.recordID - 整改记录ID
 */
export function updatePhotoRectification(params) {
  return updatePhotoRectificationAction(params)
}

export function setClientDownloadDrawerVisible(data) {
  return setClientDownloadDrawerVisibleAction(data)
}

export function setClientDownloadTasks(data) {
  return setClientDownloadTasksAction(data)
}

export function setClientDownloadProgress(data) {
  return setClientDownloadProgressAction(data)
}
